<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
       <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <!-- <el-form-item label="工厂:">
                <el-input size="small" v-model="dataForm.werks" placeholder="工厂" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item label="供应商名称:" label-width="100px">
                <el-input size="small" v-model="dataForm.name1" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料编码:" label-width="100px">
                <el-input size="small" v-model="dataForm.matnr" placeholder="物料编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="内向交货单号:" label-width="100px">
                <el-input size="small" v-model="dataForm.vbeln" placeholder="内向交货单号" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="采购订单号:" label-width="100px">
                <el-input size="small" v-model="dataForm.ebeln" placeholder="采购订单号" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="工厂:" label-width="100px">
                <el-select v-model="dataForm.werks" filterable clearable placeholder="请选择" @change="getDataList">
                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="工厂:">
                <el-input size="small" v-model="dataForm.werks" placeholder="工厂" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建项目
                </el-button> -->
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="lifnr" header-align="center" align="center" label="供应商编码" width="100">
                </el-table-column>
                <el-table-column prop="name1" header-align="center" align="center" label="供应商名称" width="120">
                </el-table-column>
                <el-table-column prop="vbeln" header-align="center" align="center" label="ASN单号" width="100">
                </el-table-column>
                <el-table-column prop="ebeln" header-align="center" align="center" label="采购订单号" width="100">
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="center" label="物料编码" width="100">
                </el-table-column>
                <el-table-column prop="maktx" header-align="center" align="center" label="描述" width="100">
                </el-table-column>
                <el-table-column prop="menge" header-align="center" align="center" label="数量" width="100">
                </el-table-column>
                <el-table-column prop="meins" header-align="center" align="center" label="基本单位" width="70">
                    <template slot-scope="scope">
                        <span>{{getUnitName(scope.row.meins)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bwart" header-align="center" align="center" label="移动类型" width="70">
                </el-table-column>
                <el-table-column prop="gjahr" header-align="center" align="center" label="物料凭证年度" width="100">
                </el-table-column>
                <el-table-column prop="bldat" header-align="center" align="center" label="凭证日期" :formatter="dateFormat" width="120">
                </el-table-column>
                <el-table-column prop="budat" header-align="center" align="center" label="过账日期" :formatter="dateFormat" width="120">
                </el-table-column>
                <el-table-column prop="belnr" header-align="center" align="center" label="物料凭证号" width="100">
                </el-table-column>
                <el-table-column prop="buzei" header-align="center" align="center" label="物料凭证项目" width="100">
                </el-table-column>
                <el-table-column prop="ebelp" header-align="center" align="center" label="采购订单项目编号" width="120">
                </el-table-column>
                <el-table-column prop="charg" header-align="center" align="center" label="批次" width="70">
                </el-table-column>
                <el-table-column prop="werks" header-align="center" align="center" label="工厂" width="150">
                    <template slot-scope="scope">
                        <span>{{getFactoryName(scope.row.werks)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sgtxt" header-align="center" align="center" label="项目文本" width="100">
                </el-table-column>
                <el-table-column prop="lgort" header-align="center" align="center" label="库存地点" width="70">
                </el-table-column>
                <el-table-column prop="lgobe" header-align="center" align="center" label="库存地点名称" width="150">
                </el-table-column>
                <!-- <el-table-column header-align="center" align="left" width="80" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    getDeliveryHistoryList,
    removeDeliveryHistory,
    // list
} from '@/controller/sap'
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
import AddOrUpdate from './delivery-history-add-or-update'
import moment from 'moment'
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                lifnr: '',
                name1: '',//供应商名称
                matnr: '',//物料编码
                vbeln: '',//内向交货单号
                ebeln: '',//采购订单号
                werks: '',//工厂
                belnr: '',
                gjahr: '',
                bldat: '',
                budat: '',
            },
            dataList: [],
            tenantList: [],
            factoryList: [],
            unitList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 260
            }
        }
    },

    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            getDeliveryHistoryList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'lifnr': this.dataForm.lifnr,
                'name1': this.dataForm.name1,//供应商名称
                'belnr': this.dataForm.belnr,//物料凭证号
                'gjahr': this.dataForm.gjahr,//物料凭证年度
                'matnr': this.dataForm.matnr,//物料编码
                'vbeln': this.dataForm.vbeln,//内向交货单号
                'ebeln': this.dataForm.ebeln,//采购订单号
                'werks': this.dataForm.werks,//工厂
                'bldat': this.dataForm.bldat,
                'budat': this.dataForm.budat,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                    console.log(this.dataList,"this.dataList")
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.getUnitList()
                this.getFactoryList()
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        //获取单位数据
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        getFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            return factory ? factory.factoryDesc : ''
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
    }
}
</script>